import { Stack } from "@mui/material";
import { SystemSettingType } from "Infrastructure/Api/Api";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { SystemSettingController } from "Components/System/SystemSettingController";
import { VatStatusRefreshContent } from "Components/System/VatStatusRefreshContent";
import { PaymentSimulationContent } from "Components/System/PaymentSimulationContent";
import { SettlementPoolBoostsContent } from "Components/Settlements/PoolBoost/SettlementPoolBoostsContent";

const Setting: React.FunctionComponent<
  React.PropsWithChildren<{ type: SystemSettingType }>
> = ({ type }) => {
  return <SystemSettingController type={type} />;
};

export const SystemControlPage = () => {
  return (
    <AuthenticatedLayout title="Nastavení systému">
      <StyledPageWrapper>
        <Stack gap={3}>
          <PrimaryPaper>
            <Stack gap={3}>
              <Setting type={SystemSettingType.SendinblueEmails} />
            </Stack>
          </PrimaryPaper>
          <SettlementPoolBoostsContent />
          <VatStatusRefreshContent />
          <PaymentSimulationContent />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default SystemControlPage;
